import React from "react";
import './Navbar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse, faArrowRotateLeft, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import {Link} from "react-router-dom";


const Navbar = (props)=>{
    return(
        <>
            {/* <div classNameName="container-fluid header" style={{color : props.mode === 'dark' ? "white" : "black"}}>
                <center>

                <div classNameName="row main-nav">
                    <div classNameName="col-sm-2">
                        <div classNameName="title">
                            
                                <h4 classNameName="title-head">Sannu.</h4>
                            
                        </div>
                    </div>
                    <div classNameName="col-sm-8"></div>
                    <div classNameName="col-sm-2">
                        <div classNameName="row">
                            <div classNameName="col-md-6">
                            
                            <Link style={{color : props.mode === 'dark' ? "white" : "black"}} to="/"><FontAwesomeIcon icon={faArrowRotateLeft} size="2x" style={{color: "#11111",}}/></Link>
                            
                            </div>
                            <div classNameName="col-md-6">
                            
                            <Link style={{color : props.mode === 'dark' ? "white" : "black"}} to="/contact">
                            <FontAwesomeIcon icon={faEnvelope} size="2x" style={{color: "#11111",}}/></Link>

                            </div>
                        </div>
                    </div>
                </div>
                </center>
            </div> */}
            <nav className="container" style={{color : props.mode === 'dark' ? "white" : "black"}}>
        <h4 className="title-head">Sannu.</h4>
        <ul>
          <li><Link style={{color : props.mode === 'dark' ? "white" : "black",
        
            
            
            }} to="/" className="link">HOME</Link></li>
          <li><Link style={{color : props.mode === 'dark' ? "white" : "black"}} to="/contact" className="link">CONTACT</Link></li>
          {/* <li><a href="#">Item 3</a></li> */}
        </ul>
      </nav>
        </>
    );
}

export default Navbar;